import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DataCenterProcessListComponent } from "./data-center-process-list/data-center-process-list.component";
import { DataCenterProcessFormComponent } from "./data-center-process-form/data-center-process-form.component";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { FormsModule } from "@angular/forms";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
const components = [DataCenterProcessListComponent, DataCenterProcessFormComponent];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule.forRoot(), SepidzGridModule],
})
export class DataCenterProcessModule {}
